export default __webpack_public_path__ + "static/media/campus (6).c98525b3.JPG";